/**
 * Simple cookie helpers for persisting UI preferences.
 */

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name: string, value: string, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getCookieBool(name: string, defaultValue: boolean): boolean {
  const val = getCookie(name);
  if (val === null) return defaultValue;
  return val === 'true';
}

export function setCookieBool(name: string, value: boolean) {
  setCookie(name, String(value));
}
